import type { Table } from '@tanstack/react-table'
import { Spinner } from '~/shadcn/ui/spinner'
import type { FilterOptionValues } from '~/@mid_ui/table/tableFilterOptions'
import { MultiSelect } from '~/@pages_investing/projects/_projects_filtering/MultiSelect'
import type { Investment } from '../_investment_types/investment.types'
import { useInvestmentsDateFiltersQuery } from './useInvestmentsDateFiltersQuery'

type InvestmentDateFiltersProps = { table: Table<Investment> }

function InvestmentDateFilters(props: InvestmentDateFiltersProps) {
  const { latestPaymentYearsOptions, investmentYearsOptions, isLoading } =
    useInvestmentsDateFiltersQuery()

  if (isLoading) return <Spinner />

  return (
    <>
      <MultiSelect
        colorScheme="light"
        label="Dátum investície"
        options={investmentYearsOptions}
        disabled={investmentYearsOptions.length === 0}
        values={
          props.table
            .getColumn('createdAt')!
            .getFilterValue() as FilterOptionValues<
            typeof investmentYearsOptions
          >
        }
        onChange={props.table.getColumn('createdAt')!.setFilterValue}
      />
      <MultiSelect
        colorScheme="light"
        label="Dátum splatenia"
        options={latestPaymentYearsOptions}
        disabled={latestPaymentYearsOptions.length === 0}
        values={
          props.table
            .getColumn('latestPaymentDate')!
            .getFilterValue() as FilterOptionValues<
            typeof latestPaymentYearsOptions
          >
        }
        onChange={props.table.getColumn('latestPaymentDate')!.setFilterValue}
      />
    </>
  )
}

export { InvestmentDateFilters }
